import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PageBuilder } from '../utils/page-builder';

export type BorderStyle = 'all' | 'left' | 'right';

@Component({
  selector: 'ps-ui-paginated-list',
  templateUrl: './paginated-list.component.html',
  styleUrls: ['./paginated-list.component.css'],
})
export class PaginatedListComponent implements OnChanges {
  @Input()
  public border: BorderStyle = 'right';

  @Input()
  public length: number = 0;

  @Input()
  public limit: number = 10;

  @Output()
  public pageChange = new EventEmitter<number>();

  public pages: number[] = [];
  public selectedPage: number = 1;

  public ngOnChanges(_: SimpleChanges): void {
    this.pages = new PageBuilder(this.length, this.limit).generate();
    this.selectedPage = 1;
  }

  public onPageChange(page: number): void {
    this.selectedPage = page;
    this.pageChange.emit(this.selectedPage);
  }
}
